import { FormattedNumber } from "react-intl";
import classNames from "classnames";
import { isNumber } from "lodash";

const BudgetAmount = ({ amount, unit = "€", ...props }) => {
  const value = isNumber(amount) ? amount : 0;
  const isEuro = unit === "€";

  const colorClass = value < 0 ? "text-danger" : "text-success";
  const className = classNames("nowrap", colorClass, props.className);

  return (
    <span className={className}>
      {value > 0 ? "+" : ""}
      {isEuro ? (
        <FormattedNumber value={value} style="currency" currency="EUR" />
      ) : (
        <>
          <FormattedNumber value={value} style="decimal" />
          {unit && ` ${unit}`}
        </>
      )}
    </span>
  );
};

export default BudgetAmount;
